import "./Datasources.scss";
import { useEffect, useState, useContext } from "react";
import {
  Col,
  Row,
  Select,
  Button,
  Input,
  Tooltip,
  Form,
  Table,
  Modal,
  Upload,
  Icon,
  notification,
  Spin
} from "antd";

import { useTranslation } from "react-i18next";
import { globalContext } from "../../../../../../contexts";
import { saveDataSourcePromise, deleteDataSourcePromise } from "../../promises";
import apiConfig from "../../../../../../config/api";
import { SessionStorageService } from "../../../../../../services";
import { ReportService } from "../../../../../../services";
import { getTemplatesPromise } from "../../../../../AdminFormManager/promises/formManagerPromises";

const { Option, OptGroup } = Select;
const { TextArea } = Input;

const Datasources = ({ formId, field, handleClickSelect, closeModalHandler }) => {
	const { t, i18n } = useTranslation('forms')
	const { datasources, loadFormDatasource } = useContext(globalContext)
    const [ editDS, setEditDS ] = useState(false)
    const [ selectedDS, setSelectedDS ] = useState(null)
    const [ textValues, setTextValues ] = useState(null)
    const [ enableSave, setEnableSave ] = useState(false)
    const [ isVisibleNew, setIsVisibleNew ] = useState(false)
    const [ selectedValueDS, setSelectedValueDS ] = useState(null)
    const [ valueNewDS, setValueNewDS ] = useState(null)
    const [ importing, setImporting ] = useState(false)
    const [ loading, setLoading ] = useState(false)
    const authToken = SessionStorageService.read('authToken')
    const lng = i18n.language.substring(0,2)

    useEffect(() => {
        loadFormDatasource(formId, null, true);
        if(field.source && field.source.indexOf(':') >0) {
            handleChangeDatasource(field.source)
        }
    }, [])

    const getColsDS = (ds) => {
        let cols = [
            {
                title: t('forms.language.es'),
                dataIndex: 'jsonValue',
                render: (text, record) => {
                    return text?.es
                }
            },
            {
                title: t('forms.language.en'),
                dataIndex: 'jsonValue',
                render: (text, record) => {
                    return text?.en
                }
            },
            {
                title: t('forms.language.pt'),
                dataIndex: 'jsonValue',
                render: (text, record) => {
                    return text?.pt
                }
            }
        ]
        if(ds.parent && datasources.CAT[ds.parent]) {
            cols.push(
                {
                    title: t('forms.label.groupedBy'),
                    dataIndex: 'jsonValue',
                    render: (text, record) => {
                        const parent = datasources.CAT[ds.parent].values.filter(v => v.code === record.parent)
                        return parent?.length === 1 ? parent[0].jsonValue[lng] : record.parent
                    }
                }
            )
        }

        return cols
    }
    
    const handleChangeDatasource = (value) => {
        let data = value.split(':')
        if(value === 'FORM:NEW') {
            setSelectedValueDS(value)
            setValueNewDS(null)
            setIsVisibleNew(true)
        }else {
            if(datasources[data[0]] && datasources[data[0]][data[1]]) {
                setSelectedDS(datasources[data[0]][data[1]])
                setSelectedValueDS(value)
            }else {
                setSelectedValueDS("[N/A]")
            }
        }
    }

    const handleEditDS = () => {
        if(!editDS) {
            setTextValues(getTextDS())
        }
        setEditDS(!editDS)
        setEnableSave(false)
    }

    const getTextDS = () => {
        let text = ''
        selectedDS && selectedDS.values && selectedDS.values.map((t,index) => {
            text += t.value
            if(index < (selectedDS.values.length-1)) text += '\n'
        })
        return text
    }

    const handleDeleteDS = () => {
        setLoading(true)
        getTemplatesPromise({ds: selectedValueDS}).then(r => {
            setLoading(false)
            let msg = t('forms.confirm.deleteds')
            if(r.length > 0) {
                msg = <div style={{paddingTop:10}}><p>{t('forms.confirm.relatedds', {cant: r.length})}</p><p>{msg}</p></div>
            }
            Modal.confirm({
                title: t("messages.aml.confirm", {ns: 'translations'}),
                content: msg,
                okText: t('messages.aml.confirm', {ns: 'translations'}),
                cancelText: t('messages.aml.cancel', {ns: 'translations'}),
                onOk: () => {
                    const data = selectedValueDS.split(":")
                    deleteDataSourcePromise(data[1]).then(r => {
                        loadFormDatasource(formId, () => {
                            handleEditDS()
                            setSelectedDS(null)
                            setSelectedValueDS(null)
                            setTextValues(null)
                        });
                    })
                }
            })
        })
    }
    
    const handleSaveDS = () => {
        let val = textValues.split('\n')
        let line
        try {
            let values = []
            val.map(v => {
                if(v !== "") {
                    line = v
                    values.push({value: v, jsonValue: JSON.parse(v)})
                }
            })
            let sDS = { ...selectedDS, values}

            saveDataSourcePromise(formId, sDS).then(r => {
                setSelectedDS(sDS)
                handleEditDS()
                loadFormDatasource(formId)
            }).catch(e => {
                notification.error({
                    message: t('forms.errors.error'),
                    description: t('forms.errors.saveOptionsError')
                })
            })
        } catch(e) {
            notification.error({
                message: t('forms.errors.error'),
                description: <>
                                <p>{t('forms.errors.jsonLineError')}</p>
                                <p>
                                    <p><b>{line}</b></p>
                                    <p>{t('forms.errors.jsonLineErrorMsg')}</p>
                                </p>
                            </>
            })
        }
    }

    const handleChangeValues = (e) => {
        setTextValues(e.target.value)
        setEnableSave(true)
    }

    const openModalNewHandler = () => {
        setIsVisibleNew(true)
    }

    const closeModalNewHandler = (accept) => {
        setIsVisibleNew(false)
    }

    const handleChangeNewDS = (e) => {
        setValueNewDS(e.target.value)
    }

    const handleSaveNewDS = () => {
        saveDataSourcePromise(formId, {description: valueNewDS, values: []}).then(code => {
            loadFormDatasource(formId, (ds) => {
                closeModalNewHandler()
                handleChangeDatasource('FORM:'+code)
                setEditDS(true)
            })
        }).catch(e => {
            notification.error({
                message: t('forms.errors.error'),
                description: t('forms.errors.saveError')
            })
        })
    }

    const handleDownload = () => {
        ReportService.read('/formManager/downloadDatasource', {id: selectedDS.id, locale: lng}, null, 'datasource.xlsx', {
        });
    }

    const propsUpload = {
      accept: ".xlsx",
      name: 'file',
      multiple: false,
      headers: {
        Authorization: 'Bearer ' + authToken
      },
      showUploadList: false,
      action: apiConfig.url + '/formManager/uploadDatasource',
      onChange(info) {
        setImporting(true)
        const { status } = info.file

        if (status === 'done') {
          notification.success({
            message: t('messages.aml.successfulOperation', {ns: 'translations'}),
            description: t('messages.aml.fileUploadedSuccesfully', {ns: 'translations'})
          })

          const customOrder = ['es', 'en', 'pt'];

          const textValues = info.file.response.map(original => {
            const ordered = customOrder.reduce((acc, key) => {
                if (key in original) {
                    acc[key] = original[key];
                }
                return acc;
            }, {});
            return JSON.stringify(ordered)
          }).join('\n')
          setTextValues(textValues)
          setEnableSave(true)
          setImporting(false)
        } else if (status === 'error') {
            if(info.file.response && info.file.response.length === 1) {
                notification.error({
                    message: "Error",
                    description: info.file.response[0].error
                })
            }else {
                notification.error({
                    message: "Error",
                    description: t('messages.aml.anErrorOcurredWhileUploadingFile', {ns: 'translation'})
                })
            }
            setImporting(false)
        }
      },
      
    }

    return (
        <div className="form-manager-datasources-edit">
            { loading &&
                <div className="loading-ds">
                    <Spin size="large"/>
                </div>
            }
            <Row>
              { datasources &&
              <>
                <Form.Item label={t('forms.label.selectDatasource')}>
                    <Col span={21}>
                        <Select className="form-datasource" onChange={handleChangeDatasource} value={selectedValueDS} disabled={editDS}>
                            <OptGroup label={t('forms.confirm.ds.mydata')}>
                                { datasources.FORM && Object.values(datasources.FORM)
                                    .sort((a, b) => a.description > b.description ? 1 : -1)
                                    .map(ds =>
                                <Option value={'FORM:'+ds.code}>
                                    <Col span={22}>{ds.description}</Col>
                                    <Col span={2}>{ds.values.length}</Col>
                                </Option>            
                                )}
                            </OptGroup>
                            { datasources.CAT && 
                            <OptGroup label={t('forms.confirm.ds.system')}>
                                { Object.values(datasources.CAT)
                                    .sort((a, b) => a.description > b.description ? 1 : -1)
                                    .map(ds =>
                                <Option value={'CAT:'+ds.code}>
                                    <Col span={22}>{t('forms.confirm.ds.CAT.'+ ds.code)}</Col>
                                    <Col span={2}>{ds.values.length}</Col>
                                </Option>            
                                )}
                            </OptGroup>
                            }
                        </Select>
                    </Col>
                    <Col span={3} className="tools-datasources">
                        { !editDS &&
                        <>
                            <Tooltip title={t('forms.confirm.ds.new')}>
                                <Button size="small" icon="plus" onClick={openModalNewHandler}/>
                            </Tooltip>
                            &nbsp;
                        </>
                        }
                        { selectedDS &&
                            <>
                            { !editDS ?
                                <Tooltip title={t('forms.tooltip.editOptions')}>
                                    <Button size="small" icon="edit" disabled={!selectedValueDS || !selectedValueDS.startsWith('FORM')} onClick={handleEditDS}/>
                                </Tooltip>
                                :
                                <>
                                    <Tooltip title={t('forms.tooltip.cancel')}>
                                        <Button size="small" icon="close" onClick={handleEditDS}/>
                                    </Tooltip>
                                    &nbsp;
                                    { selectedValueDS && selectedValueDS.startsWith('FORM') &&
                                    <>
                                        <Tooltip title={t('forms.tooltip.save')}>
                                            <Button size="small" icon="save" type="primary" onClick={handleSaveDS} disabled={!enableSave}/>
                                        </Tooltip>
                                        &nbsp;
                                        <Tooltip title={t('forms.tooltip.delete')}>
                                            <Button size="small" icon="delete" type="primary" onClick={handleDeleteDS} />
                                        </Tooltip>
                                    </>
                                    }
                                </>
                            }
                            </>
                        }
                    </Col>
                </Form.Item>
                { selectedDS && 
                <>
                    { editDS ?
                        <>
                            <Row>
                                <Col span={12}>
                                    <h4 className="title-datasource-values">{t('forms.label.options')}</h4>
                                </Col>
                                <Col span={12} style={{textAlign:'right'}}>
                                    <Button onClick={handleDownload}><Icon type="arrow-down" /> {t('forms.buttons.export')}</Button>
                                    &nbsp;
                                    <Upload {...propsUpload} >
                                        <Button loading={importing}>{!importing && <Icon type="arrow-up" />} {t('forms.buttons.import')}</Button>
                                    </Upload>
                                </Col>
                                
                            </Row>
                            <Row>
                                <Col>
                                    <TextArea rows={10} value={textValues} onChange={handleChangeValues} placeholder={t('forms.placeholder.enterOptions')}/>
                                </Col>
                            </Row>
                        </>
                    :
                        <Table columns={getColsDS(selectedDS)} size="small" dataSource={selectedDS.values} pagination={{ defaultPageSize: 5}}/>
                    }
                </>
                }
                <Row className="tools-datasource">
                    <Button onClick={closeModalHandler}>{t('messages.aml.form.template.close', {ns: 'forms'})}</Button>
                    <Button type="primary" onClick={() => handleClickSelect(selectedValueDS)} disabled={editDS || !selectedDS}>{t('forms.buttons.apply')}</Button>
                </Row>
              </>
              }
            </Row>

            { isVisibleNew &&
                <Modal title={t('forms.modal.newDatasourceTitle')}
                    className="modal-new-datasource"
                    footer={ null }
                    visible={ true }
                    onOk={ () => closeModalNewHandler(true)  }
                    onCancel={ () => closeModalNewHandler(false) }

                    >
                    <Form.Item label={t('forms.label.enterName')}>
                        <Input value={valueNewDS} onChange={handleChangeNewDS}/>
                    </Form.Item>
                    <Row className="tools-datasource">
                        <Button type="primary" onClick={handleSaveNewDS} disabled={valueNewDS === null || valueNewDS === ''} >{t('forms.buttons.accept')}</Button>
                    </Row>
                </Modal>
            }
        </div>
    )
}
export default Datasources;
    